const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileSiteSeeLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.8 35.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "406.9 18.2 406.9 15.7 409.1 16.9 411.3 18.2 409.1 19.4 406.9 20.7 406.9 18.2",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M338.5,18.2c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2,1-2.2,2.2-2.2,2.2,1,2.2,2.2",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M312.3,10h-5.5l4.7,14.9c.4,1.1.7,1.5,1.9,1.5h1.5v-6.5l-2.5-10h-.1Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M318.7,10l-2.5,9.9v6.5h1.1c1.1,0,1.5-.4,1.9-1.5l4.7-14.9h-5.2Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M386,10.1h-4.9v16.2h4.9V10.1Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M395.5,22.3c0-2.4-1-2.9-2.6-3.3h0c1.9-.4,2.8-1.3,2.8-4.4s-.3-3.1-1.1-3.8c-.6-.6-1.5-.8-3.2-.8h-4v3.7h1.3c.9,0,1.1,0,1.3.2.2.2.4.6.4,1.5s-.1,1.4-.4,1.6c-.1.1-.4.2-1.3.2h-1.3v3.5h1.1c1,0,1.2,0,1.5.3.3.2.4.5.4,1.7s.1,2.5.3,3.6h5.1c0-.9-.2-2.5-.3-4.1",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M405.5,16.3h0v-2.5h0v2.5Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M405.5,22.6h0v-2.8h0v2.8Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M405.5,10.1h-4.9v16.2h4.9V10.1Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M413.8,10.1h-6.8v3.6h6.8v-3.6Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    d: "M413.8,26.3h0v-3.6h-6.8v3.6h6.8Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    d: "M377.2,13.8h0v-3.7h-14.6v3.7h14.6Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    d: "M367.4,26.3h4.9v-11h-4.9v11Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    d: "M354.4,22.4c-.1.1-.4.2-1.1.2h-2.1c-.7,0-.9,0-1.1-.2s-.4-.5-.4-3.5h-5.2c0,4,.9,5.7,1.8,6.6.6.6,1.5.9,3.2.9h5.5c1.7,0,2.6-.3,3.2-.9.8-.8,1.2-2.3,1.3-5.6h-4.7c0,2.1-.3,2.4-.4,2.5",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    d: "M350.2,14c.1-.1.4-.2,1.1-.2h2.1c.7,0,.9,0,1.1.2.1.1.3.4.4,2.5h4.7c0-3.3-.4-4.7-1.3-5.5-.6-.6-1.5-.9-3.2-.9h-5.5c-1.7,0-2.6.3-3.2.9-.9.9-1.7,2.5-1.8,6.6h5.2c0-2.9.3-3.3.4-3.5",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-30",
    d: "M332.6,10.1h-4.9v16.2h4.9V10.1Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    d: "M340.9,26.3h0v-3.6h-6.8v3.6h6.8Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    d: "M340.9,13.8h0v-3.6h-6.8v3.6h0s6.8,0,6.8,0Z",
    style: {
      fill: "#c87349",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    points: "292.6 22.3 293.2 22.6 293.6 22.3 293.6 19.4 292.6 20.2 292.6 22.3",
    style: {
      fill: "#025061",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    points: "294.4 18.1 295.5 17.2 295.6 17.2 295.6 14.6 294.4 15.5 294.4 18.1",
    style: {
      fill: "#025061",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-40",
    d: "M300.4,19.2h-.3l-.8-.4-.7,1.1c0,.1-.1.1-.3,0l-1-.6s-.1-.1-.1-.2v-2.6h-.3c0-.1-.7.6-.7.6v3.7c0,.1-.1.2-.2.1l-.4-.3s-.1-.1-.1-.2v-2.8l-1.1,1v3.5l-1,1h-.3l-1.1-.6s-.1-.1-.1-.2v-1.9c0-.1,0-.2.1-.2l1.7-1.5v-2.8l-1.7,1.2c-.1,0-.2,0-.2-.1v-.2s0-.2.1-.2l4.3-3.1c.1,0,.2,0,.2.1h0v2.8l.7-.7h.3l.7.3s.1,0,.1.2v2.9l.4.2.5-.8h0v-3.4l.7-.6h.3l1.1.6c.1,0,.1.2,0,.3l-1.4,2.3v.7l.6.3,1.5-1.6h.3c.1.1.1.2,0,.3l-1.8,1.9h0ZM296.8,10v1.8h-1.4v-1.8c-4.2.4-7.6,3.9-7.6,8.2s3.3,7.9,7.6,8.2v-2.2h1.4v2.2c4.2-.4,7.6-3.9,7.6-8.2s-3.3-7.9-7.6-8.2h0Z",
    style: {
      fill: "#025061",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    points: "300.7 15.3 299.9 14.8 299.8 15 299.8 16.7 300.7 15.3",
    style: {
      fill: "#025061",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "by",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.7,21.6h-1v-8.7h1.1v3.1c.4-.6,1-.8,1.7-.8s.8,0,1.1.2c.3.2.6.4.9.7.2.3.4.6.5,1s.2.8.2,1.3c0,1.1-.3,1.9-.8,2.5-.5.6-1.2.9-1.9.9s-1.3-.3-1.7-.9v.8ZM264.7,18.4c0,.8.1,1.3.3,1.6.3.5.8.8,1.4.8s.9-.2,1.2-.6c.3-.4.5-1,.5-1.8s-.2-1.4-.5-1.8-.7-.6-1.2-.6-.9.2-1.2.6c-.3.4-.5,1-.5,1.8Z",
    style: {
      fill: "#025061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4,24v-1c.1,0,.3,0,.5,0s.4,0,.6-.1c.1,0,.3-.2.3-.3,0-.1.2-.4.3-.8,0,0,0-.1,0-.3l-2.4-6.3h1.1l1.3,3.6c.2.5.3.9.5,1.5.1-.5.3-1,.4-1.4l1.3-3.7h1.1l-2.4,6.4c-.3.7-.5,1.2-.6,1.4-.2.4-.4.6-.7.8-.2.2-.5.2-.9.2s-.4,0-.7-.1Z",
    style: {
      fill: "#025061"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.1 6.5 0 6.5 0 .5 25.6 .5 25.6 6.5 16.5 6.5 16.5 34.8 9.1 34.8 9.1 6.5",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4,13.6c0-4.8-.7-7.4-2.4-9.6-2.2-2.8-5.4-4-10.6-4s-7.8,1-10.1,3.5c-2.1,2.2-2.9,5-2.9,10.1v8.1c0,4.7.7,7.4,2.4,9.6,2.3,2.9,5.5,4.1,10.6,4.1s7.8-1,10.1-3.5c2.1-2.2,2.9-5,2.9-10.1v-8.1h0ZM41.4,29.4c-4.2,0-5.6-2.1-5.6-8.3v-6.8c0-6.2,1.4-8.3,5.6-8.3s5.6,2.1,5.6,8.3v6.8c0,6.2-1.4,8.3-5.6,8.3Z",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,.5v21.5c0,2.8.2,4.1.7,5.2.8,1.6,2.1,2.2,4.6,2.2s3.9-.7,4.7-2.6c.4-1,.6-2.4.6-4.8V.5h7.4v21.5c0,5.1-.5,7.4-2.1,9.4-2.3,2.8-5.3,3.9-10.6,3.9s-8.9-1.4-11-4.6c-1.2-1.9-1.7-4.1-1.7-8.8V.5h7.4Z",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.2,20.6c4.4-1.3,6.2-4.1,6.2-10s-.8-5.9-2.5-7.6c-1.8-1.8-4.3-2.5-8.9-2.5h-13v34.3h7.4v-13.6h3.6l6.4,13.6h8.2s-7.4-14.2-7.4-14.2ZM103.4,15.5h-5.1V6.4h5c3.5,0,4.8,1.2,4.8,4.6s-1.3,4.6-4.7,4.6h0Z",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,17.4h10.4v5.1c0,4.4-.8,7-2.7,9.2-2.1,2.4-5,3.5-8.9,3.5s-7.4-1.5-9.4-4.4c-1.5-2.2-2.1-4.9-2.1-9.7v-6.8c0-5.3.7-8.1,2.5-10.4,2-2.5,4.9-3.7,8.8-3.7,6.1,0,10.2,3.1,10.5,7.9l-2.2.2c-.6-3.8-3.7-6.1-8.3-6.1s-9.1,3.7-9.1,12.2v6.8c0,8.5,2.8,12.1,9.2,12.1s5.7-1.1,7.3-3.2c1.4-1.8,1.9-3.7,1.9-7.1v-3.5h-8.1v-2h.2Z",
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5.5v21.8c0,3.9.4,5.7,1.5,7.4,1.6,2.4,3.8,3.5,7.4,3.5s6.2-1.3,7.7-4c.9-1.5,1.2-3.4,1.2-6.9V.5h2.3v21.8c0,4.7-.5,6.8-2,8.9-2.1,2.7-4.9,4-9.2,4s-7.6-1.5-9.6-4.6c-1.2-1.9-1.6-3.9-1.6-8.3V.5h2.3Z",
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.1,
    y: 0.5,
    width: 2.3,
    height: 34.3,
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,13.3c.2-8.3-4.2-13-12.1-12.9h-10.4v34.3h10.4c7.9,0,12.3-4.6,12-12.9v-8.5h.1ZM206.2,32.7h-7.8V2.4h7.8c6.7,0,10.2,3.7,10,11.1v7.9c.1,7.4-3.4,11.3-10,11.2h0Z",
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.2 .5 246.4 .5 246.4 2.5 229.5 2.5 229.5 16.4 243.9 16.4 243.9 18.4 229.5 18.4 229.5 32.7 246.3 32.7 246.3 34.7 227.2 34.8 227.2 .5",
    style: {
      fill: "#c77349"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSiteSeeLogo);
export default __webpack_public_path__ + "static/media/MobileSiteSeeLogo.4f245cd953c3c886380a61ebbdfcd663.svg";
export { ForwardRef as ReactComponent };